<template>
  <DataList
    title="Витрата товару"
    resource="product-consumptions"
    :columns="columns"
    :get-items-fn="getProductConsumptions"
  />
</template>

<script>
import DataList from "../../../components/DataList.vue";
import * as productConsumptionsApi from "../../backend/productConsumptionsApi.js";

export default {
  components: {
    DataList,
  },
  data: () => ({
    columns: [
      { title: "Дата і час", name: "date", type: "datetime" },
      { title: "Контрагент", name: "client" },
      { title: "Товар", name: "product" },
      { title: "Кількість", name: "amount" },
      { title: "Ціна", name: "price" },
      { title: "Сума", name: "totalPrice" },
      { title: "Відповідальний ", name: "user" },
    ],
  }),
  methods: {
    async getProductConsumptions(...args) {
      const data = await productConsumptionsApi.getProductConsumptions(args[0], args[1], args[2], args[3]);
      data.result = data.result.map(e=>{
        return {
          id: e.id,
          date: e.date,
          client: e.client.title,
          product: e.product.title,
          price: e.price,
          amount: e.amount,
          totalPrice: e.totalPrice,
          user: e.user.title,
          description: e.description,
        };
      });
      return data;
    },
  },
};
</script>